import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubjectService } from 'src/app/utility-packages/is-logged-in/behaviorSubject.service';
import { CookieManagementService } from './cookie-management.service';

@Injectable({
  providedIn: 'root'
})
export class LogoutService {

  constructor(
    private cookieManagementService: CookieManagementService,
    private behaviorSubjectService: BehaviorSubjectService,
    private router: Router
  ){}

  logOut(){
    this.cookieManagementService.logOut();
    this.behaviorSubjectService.changeUserLoginStatus(false);
  }
}
